import { fmtMoney } from "../lib/api";
import CrudPage from "../components/CrudPage";

const METHOD_OPTIONS = [
  { value: "nakit", label: "Nakit" },
  { value: "kredi_karti", label: "Kredi Kartı" },
  { value: "havale", label: "Havale" },
];
const METHOD_LABELS = { nakit: "Nakit", kredi_karti: "Kredi Kartı", havale: "Havale" };

const config = (kind) => ({
  title: kind === "income" ? "Gelir" : "Gider",
  subtitle: kind === "income" ? "Gelir kayıtları - kasa otomatik güncellenir" : "Gider kayıtları - kasa otomatik güncellenir",
  module: kind,
  endpoint: kind === "income" ? "/income" : "/expenses",
  addLabel: kind === "income" ? "Yeni Gelir" : "Yeni Gider",
  defaultValues: { method: "nakit", date: new Date().toISOString().slice(0, 10) },
  columns: [
    { key: "title", label: "Başlık", render: (r) => <span className="font-medium">{r.title}</span> },
    { key: "category", label: "Kategori" },
    { key: "date", label: "Tarih" },
    {
      key: "amount", label: "Tutar",
      render: (r) => (
        <span className={`font-semibold ${kind === "income" ? "text-emerald-600" : "text-red-500"}`}>
          {kind === "income" ? "+" : "-"}{fmtMoney(r.amount)}
        </span>
      ),
    },
    { key: "method", label: "Yöntem", render: (r) => METHOD_LABELS[r.method] || r.method },
    { key: "note", label: "Not" },
  ],
  fields: [
    { name: "title", label: "Başlık", required: true },
    { name: "category", label: "Kategori", placeholder: "Kira, Fatura, Maaş..." },
    { name: "amount", label: "Tutar (₺)", type: "number", required: true },
    { name: "method", label: "Yöntem", type: "select", options: METHOD_OPTIONS },
    { name: "date", label: "Tarih", type: "date", required: true },
    { name: "note", label: "Not", type: "textarea" },
  ],
});

export const IncomePage = () => <CrudPage {...config("income")} />;
export const ExpensePage = () => <CrudPage {...config("expense")} />;
